import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {DonateColumnsQuote,DonateColumnsFullCol} from '../donateColumnsItem'

class DonateColumns extends React.Component{
    constructor(props) {
        super(props)
        let data=props.data;
        this.state = {
            data: data,
        };
    }
    render() {
        let listColItem = this.state.data;
        let nameClass = `col-donate__item`;
        return (
            <div className={nameClass} >
                    <DonateColumnsQuote data={listColItem} />
            </div>
        )
    }
}

export default DonateColumns;
